import { gql } from '@common/hooks';
import {
  StaffingRequestAssignmentWithCommentsFragment,
  StaffingRequestAssignmentWithCommentsFragmentType,
} from '@working-experience/graphql/fragments';

export const CreateStaffingRequestAssignmentComment = gql`
  mutation CreateStaffingRequestAssignmentComment(
    $staffingRequestAssignmentId: String!
    $input: CreateStaffingRequestAssignmentCommentInput!
  ) {
    createStaffingRequestAssignmentComment(
      staffingRequestAssignmentId: $staffingRequestAssignmentId
      input: $input
    ) {
      staffingRequestAssignment {
        ...StaffingRequestAssignmentFragment
      }
    }
  }
  ${StaffingRequestAssignmentWithCommentsFragment}
`;

export type CreateStaffingRequestAssignmentCommentArgs = {
  staffingRequestAssignmentId: string;
  input: {
    contentAsText: string;
    notifyUsers: boolean;
  };
};

export type CreateStaffingRequestAssignmentCommentResponse = {
  createStaffingRequestAssignmentComment: {
    staffingRequestAssignment: StaffingRequestAssignmentWithCommentsFragmentType;
  };
};
